import React from 'react';
import { motion } from 'framer-motion';
import { Eye, Flame, Puzzle, HeartHandshake } from 'lucide-react';
const pillars = [{
  num: '01',
  title: 'Reflecție',
  icon: Eye,
  desc: 'Înveți să îți înțelegi blocajele reale, să le conștientizezi și să vezi exact ce te-a ținut pe loc până acum. Fără judecată, cu claritate.'
}, {
  num: '02',
  title: 'Renunțare',
  icon: Flame,
  desc: 'Primești tehnici concrete ca să lași jos fricile, emoțiile stagnante și gândirea limitativă care îți consumă energia zi de zi.'
}, {
  num: '03',
  title: 'Restructurare',
  icon: Puzzle,
  desc: 'Afli cum să îți creezi un nou mod de a gândi și de a acționa, aliniat cu cine vrei să devii, nu cu cine ai fost forțat să fii.'
}, {
  num: '04',
  title: 'Reconectare',
  icon: HeartHandshake,
  desc: 'Înveți cum să revii în relațiile tale cu autenticitate, curaj și echilibru. Și cum să rămâi conectat la tine indiferent ce se întâmplă în exterior.'
}];
export const Method = () => {
  return <section id="metoda" className="py-24 bg-[#F5FAFC] relative" data-id="element-178">
      <div className="container mx-auto px-6" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-20" data-id="element-180">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-navy mb-6" data-id="element-181">
            Metoda 4R de Recodare Mentală
          </h2>
          <p className="font-display text-royal text-lg md:text-xl" data-id="element-182">
            Un proces simplu și profund în 4 pași prin care înțelegi ce te ține
            pe loc, eliberezi ce nu mai folosești și construiești mintea cu care
            vrei să trăiești.
          </p>
        </motion.div>
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-183">
          {pillars.map((pillar, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className="relative bg-white border border-navy/10 p-8 md:p-10 group hover:border-gold/40 hover:shadow-lg transition-all duration-300" data-id="element-184">
              {/* Top gold accent line */}
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-gold/60 via-gold/30 to-transparent" data-id="element-185" />
              <div className="flex items-start gap-6" data-id="element-186">
                {/* Number + Icon column */}
                <div className="flex flex-col items-center shrink-0" data-id="element-187">
                  <span className="font-serif text-5xl font-bold text-gold leading-none mb-3" data-id="element-188">
                    {pillar.num}
                  </span>
                  <div className="w-14 h-14 rounded-full border-2 border-gold/30 flex items-center justify-center bg-gold/5 group-hover:border-gold/60 group-hover:bg-gold/10 transition-all duration-300" data-id="element-189">
                    <pillar.icon className="w-6 h-6 text-gold stroke-[1.5]" data-id="element-190" />
                  </div>
                </div>
                {/* Text content */}
                <div className="pt-1" data-id="element-191">
                  <h3 className="font-serif text-2xl md:text-3xl font-bold text-navy mb-3" data-id="element-192">
                    {pillar.title}
                  </h3>
                  <p className="font-sans text-navy/65 leading-relaxed text-base md:text-lg" data-id="element-193">
                    {pillar.desc}
                  </p>
                </div>
              </div>
              {/* Decorative corner */}
              <div className="absolute bottom-0 right-0 w-8 h-8 border-r-2 border-b-2 border-gold/20 group-hover:border-gold/40 transition-colors duration-300" data-id="element-194" />
            </motion.div>)}
        </div>
      </div>
    </section>;
};